import { Show, createResource } from "solid-js";

import { useToast } from "~/context/ToastProvider";

import { StripePayment } from '~/components';
import { isServer } from "solid-js/web";
import { useNavigate } from "@solidjs/router";
import { useProfile } from "~/context/ProfileProvider";
import { markInvoiceAsPaid, } from "~/_server/accounts";
import { updateDB,  RIASTABLE, runQueryCommand } from "~/_server";


export const PaymentPanel = ( props ) => {
	const { profile } = useProfile();
	const { addToast, toastTypes } = useToast();
	const navigate = useNavigate();

	const [intent] = createResource( profile, async ( user ) => {
		if ( !isServer ) {
			if ( user.email ) {
				const res = await fetch( "/api/stripe/create-intent", {
					method: "POST",
					body: JSON.stringify( {
						//TO DO customerId: profile().stripeId,
						amount: parseInt( props.amount ) * 100,
						email: user.email,
						name: user.name,
						descriptor: props.invoiceNumber,
						meta: {
							invoiceNumber: props.invoiceNumber,
							invoiceId: props.invoiceId,
							riasCustomerId: profile.latest?.userId
						},
						billingDetails: {
							name: user.name,
							email: user.email,
							address: {
								postal_code: user.address.postcode,
							}
						}
					} )
				} );

				return res.json();
			}
		}
	} );

	return (
		<div class="fixed inset-0 z-50 flex justify-end bg-black/40 backdrop-blur-sm [view-transition-name:payment-overlay]">
			<div class="w-96 bg-white shadow-xl p-6 transition-transform duration-300 ease-out [view-transition-name:payment-panel]" classList={{ "translate-x-[100%]": !props.open, "translate-x-[0]": props.open }}>
				<div class="flex justify-between items-center mb-4">
					<h2 class="text-xl font-semibold">Complete Payment</h2>
					<button
						type="button"
						class="text-gray-500 hover:text-black"
						onClick={props.onClose}
						aria-label="Close"
					>
						✕
					</button>
				</div>

				<p class="text-black"><span class="font-bold text-black">Invoice:</span> {props.invoiceId}</p>
				<p class="text-black mb-4"><span class="font-bold text-black">Amount:</span> £{props.amount}</p>

				<Show when={intent()}>
					<StripePayment publicKey={intent().publicKey} clientSecret={intent().clientSecret} result={async ( pi, err ) => {
						if ( err ) {
							addToast( err.message, toastTypes.error );

							return;
						}

						if ( pi.status == 'succeeded' ) {
							addToast( "Payment received - thank you!", toastTypes.success );

							try {
								await markInvoiceAsPaid( props.invoiceId, props.amount );

								const r = await runQueryCommand( {
									TableName: RIASTABLE,
									IndexName: "gsiInvoiceId",
									KeyConditionExpression: "invoiceId = :id",
									ExpressionAttributeValues: { ":id": props.invoiceId }
								} );

								if ( r?.items?.[0] ) {
									if ( r.items[0]?.recordType === "CERTIFICATE" ) {
										await updateDB( r.items[0].pk, r.items[0].sk, { status: "paid" } );
									}
								}
							} catch ( err ) {
								console.error( "Error marking invoice as paid", err );
							}

							navigate( `/dashboard/account?paymentMade=true&pi=${pi.id}`, { replace: true } );
						}
					}} />
				</Show>
			</div>
		</div>
	)
};